export default "__VITE_ASSET__CsTHg7bY__"